











import QuizContentForm from '@/web/components/quizzes/QuizContentForm.vue';
import Vue from 'vue';

export default Vue.extend({
  components: {
    QuizContentForm,
  },
  props: {
    data: {
      type: Object as () => QuizQuestionResponse,
      required: true,
    },
    showManualCheck: {
      type: Boolean,
      default: true,
    },
  },
});
